import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Buy.css";

function Buy() {

  const [buyData, setBuyData] = useState([]);
  const [imageIndex, setImageIndex] = useState({});
  const navigate = useNavigate();

  useEffect(() => {

  fetch("https://urbanbrick.in.net/get-properties.php")
    .then(res => res.json())
    .then(data => {

      const buyFiltered = data.filter(
        (item) => item.listingType === "Buy"
      );

      setBuyData(buyFiltered);

    })
    .catch(err => console.log(err));

}, []);
 

  const nextImage = (id, totalImages) => {

    setImageIndex((prev) => ({

      ...prev,

      [id]:
        (prev[id] + 1) % totalImages || 0

    }));

  };


  const prevImage = (id, totalImages) => {

    setImageIndex((prev) => ({

      ...prev,

      [id]:
        prev[id] === 0
          ? totalImages - 1
          : prev[id] - 1

    }));

  };

  return (

    <div className="buy-page">

      <h2 className="buy-title">
        Buy Properties
      </h2>

      <div className="buy-grid">

        {buyData.length === 0 ? (

          <p className="buy-empty">
            No Buy Properties Available
          </p>

        ) : (

          buyData.map((item) => {

            const currentIndex =
              imageIndex[item.id] || 0;

            return (

              <div
                className="buy-card"
                key={item.id}
              >

                {/* IMAGE WITH ARROWS */}

                <div className="buy-image-box">

                  <button
                    className="arrow left"
                    onClick={() =>
                      prevImage(
                        item.id,
                        item.images.length
                      )
                    }
                  >
                    
                  </button>

                  <img
                    src={
                      item.images?.[
                        currentIndex
                      ]
                    }
                    alt={item.title}
                    className="buy-image"
                  />

                  <button
                    className="arrow right"
                    onClick={() =>
                      nextImage(
                        item.id,
                        item.images.length
                      )
                    }
                  >
                    
                  </button>

                </div>

                <div className="buy-info">

                  <h3 className="buy-heading">
                    {item.title}
                  </h3>

                  <p className="buy-type">
                     {item.property_type}
                  </p>

                  <p className="buy-city">
                    📍 {item.city}
                  </p>

                  <p className="buy-price">
                    ₹ {item.price}
                  </p>

                  <button
                    className="buy-button"
                    onClick={() =>
                      navigate(`/property/${item.id}`)
                    }
                  >
                    View Details
                  </button>

                </div>

              </div>

            );

          })

        )}

      </div>

    </div>

  );

}

export default Buy;